export const GET_ASSORTMENT_PRODUCTS = {
  START: `ASSORTMENTS:GET_ASSORTMENT_PRODUCTS_START`,
  SUCCESS: `ASSORTMENTS:GET_ASSORTMENT_PRODUCTS_SUCCESS`,
  ERROR: `ASSORTMENTS:GET_ASSORTMENT_PRODUCTS_ERROR`,
};
